module.exports = __webpack_public_path__ + "static/media/2.2b6969de.jpg";